import { render } from "./menu-footer.vue?vue&type=template&id=413f7d38&scoped=true"
import script from "./menu-footer.vue?vue&type=script&lang=js"
export * from "./menu-footer.vue?vue&type=script&lang=js"

import "./menu-footer.vue?vue&type=style&index=0&id=413f7d38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-413f7d38"]])

export default __exports__